/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { LspReceivingProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const lspReceivingProcessFetchLspReceivingProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const lspReceivingProcessFetchLspReceivingProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [LspReceivingProcessTypes.LSP_RECEIVING_PROCESS_FETCH_LSP_RECEIVING_PROCESS_LOADING]: lspReceivingProcessFetchLspReceivingProcessLoading,
  [LspReceivingProcessTypes.LSP_RECEIVING_PROCESS_FETCH_LSP_RECEIVING_PROCESS_SUCCESS]: lspReceivingProcessFetchLspReceivingProcessSuccess
});
